// frontend/src/pages/storeActivity/StoreIdentity.jsx
//
// The top line of a staff page's store header card: the store's avatar, name
// and domain, with the pills passed as children set to the right — or on
// their own line under the name when the screen is too narrow for both.
// Shared by Store Activity and Store data health.

import React from 'react';
import { storeDisplayName, storeDomainIsDistinct } from '../../utils/avatar';
import StoreChip from '../../components/layout/StoreChip';
import '../../styles/store-activity.css';

export default function StoreIdentity({ store, children }) {
  return (
    <div className="sa-hero-top">
      <StoreChip store={store} size="lg" />
      <div className="sa-hero-title">
        <h2 className="sa-hero-name">{storeDisplayName(store)}</h2>
        {storeDomainIsDistinct(store) && <div className="sa-hero-domain">{store.domain}</div>}
      </div>
      <span className="sa-hero-pills">{children}</span>
    </div>
  );
}
